import { render } from "./UserNavbar.vue?vue&type=template&id=208c5d66&scoped=true"
import script from "./UserNavbar.vue?vue&type=script&lang=js"
export * from "./UserNavbar.vue?vue&type=script&lang=js"

import "./UserNavbar.vue?vue&type=style&index=0&id=208c5d66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208c5d66"]])

export default __exports__